// Per-device favourites — historically a flat set of video ids in the
// dedicated `crt_favourites` localStorage key. We now route both reads and
// writes through the unified `crt_viewer_prefs_v1.favourites` blob so
// signed-in viewers' stars sync to the server alongside their volume /
// phosphor / motion prefs. The legacy key is kept as a one-shot migration
// source on first load.
import { getPrefs, patchPrefs } from "@/lib/viewerPrefs";

const LEGACY_KEY = "crt_favourites";

function migrateLegacyOnce() {
  try {
    const cur = getPrefs();
    if (Array.isArray(cur.favourites) && cur.favourites.length > 0) return; // already migrated / populated
    const raw = localStorage.getItem(LEGACY_KEY);
    if (!raw) return;
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr) || arr.length === 0) return;
    patchPrefs({ favourites: arr });
    localStorage.removeItem(LEGACY_KEY);
  } catch (e) { /* noop */ }
}

function read() {
  migrateLegacyOnce();
  const prefs = getPrefs();
  return new Set(Array.isArray(prefs.favourites) ? prefs.favourites : []);
}

function write(set) {
  patchPrefs({ favourites: [...set] });
}

export function listFavourites() {
  return [...read()];
}

export function isFavourite(videoId) {
  if (!videoId) return false;
  return read().has(videoId);
}

export function toggleFavourite(videoId) {
  if (!videoId) return false;
  const set = read();
  if (set.has(videoId)) set.delete(videoId);
  else set.add(videoId);
  write(set);
  // Let listeners (e.g. the App-level channel builder) react.
  try { window.dispatchEvent(new CustomEvent("crt:favourites-changed")); } catch (e) { /* noop */ }
  return set.has(videoId);
}
